<template>
	<div>
		<v-form v-if="!validationProcess">
			<v-card class="auth-class mb-10" elevation="4">
				<v-card-text>
					<!-- name -->
					<v-text-field
						id="name-input"
						data-cy="nameInput"
						v-model.trim="$v.formData.name.$model"
						hint="Ej: Mauro Pérez"
						label="Nombre"
						dense
						filled
						outlined
						required
						:error-messages="nameErrors"
						@input="$v.formData.name.$touch()"
						@blur="$v.formData.name.$touch()"
						:append-outer-icon="
							$v.formData.name.$model && !nameErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>
					<!-- email -->
					<v-text-field
						id="email-input"
						v-model.trim="$v.formData.email.$model"
						type="email"
						hint="Ej: correo@correo.com"
						label="Correo electrónico"
						dense
						filled
						outlined
						required
						:error-messages="emailErrors"
						@input="$v.formData.email.$touch()"
						@blur="$v.formData.email.$touch()"
						:append-outer-icon="
							$v.formData.email.$model && !emailErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>
					<v-text-field
						id="re-email-input"
						v-model.trim="reEmail"
						type="email"
						hint="Ej: correo@correo.com"
						label="Repita correo electrónico"
						dense
						v-if="$v.formData.email.$model"
						filled
						outlined
						required
						:error-messages="reEmailErrors"
						:append-outer-icon="
							reEmail && !reEmailErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>

					<!-- password -->
					<v-text-field
						id="email-password"
						v-model.trim="$v.formData.password.$model"
						type="password"
						label="Contraseña"
						dense
						filled
						outlined
						required
						:error-messages="passwordErrors"
						@input="$v.formData.password.$touch()"
						@blur="$v.formData.password.$touch()"
						:append-outer-icon="
							$v.formData.password.$model && !passwordErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>
					<v-text-field
						id="email-repassword"
						v-model.trim="rePassword"
						type="password"
						label="Repita contraseña"
						dense
						filled
						v-if="$v.formData.password.$model"
						outlined
						required
						:error-messages="rePasswordErrors"
						:append-outer-icon="
							rePassword && !rePasswordErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>
					<v-text-field
						id="company-input"
						v-model.trim="$v.formData.company.$model"
						hint="Ej: Sochamar"
						label="Nombre de la empresa "
						dense
						filled
						outlined
						:error-messages="companyErrors"
						@input="$v.formData.company.$touch()"
						@blur="$v.formData.company.$touch()"
						:append-outer-icon="
							$v.formData.company.$model && !companyErrors.length
								? 'mdi-check-outline'
								: 'mdi-circle-edit-outline'
						"
					/>
					<span class="caption red--text"
						>( ! ) El <b> nombre de la empresa </b> aparecerá en todas las
						notificaciones que usted realice.</span
					>
				</v-card-text>

				<v-card-actions>
					<v-btn
						:loading="loading"
						:disabled="$v.$invalid"
						block
						color="success"
						small
						@click="onSubmit"
					>
						Finalizar registro
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { register } from '@/plugins/auth';
import { generateSnackBarError } from '@/utils/snackbar';

export default {
	mixins: [validationMixin],
	data() {
		return {
			loading: false,
			formData: {
				name: '',
				email: '',
				password: '',
				role: 'admin',
				company: '',
				phone: '',
			},
			reEmail: '',
			rePassword: '',
			validationProcess: false,
		};
	},
	computed: {
		rePasswordErrors() {
			const errors = [];
			if (this.rePassword != this.$v.formData.password.$model)
				errors.push('La contraseña no coincide');
			return errors;
		},
		reEmailErrors() {
			const errors = [];
			if (this.reEmail != this.$v.formData.email.$model) errors.push('El correo no coincide');
			return errors;
		},
		emailErrors() {
			const errors = [];
			!this.$v.formData.email.required && errors.push('El Correo electronico es querido');
			!this.$v.formData.email.email && errors.push('Escriba un email valido');
			return errors;
		},
		nameErrors() {
			const errors = [];
			!this.$v.formData.name.required && errors.push('El nombre es querido');
			!this.$v.formData.name.maxLength && errors.push('Maximo 200 caracteres');
			!this.$v.formData.name.minLength && errors.push('Minimo 3 caracteres');
			return errors;
		},
		passwordErrors() {
			const errors = [];
			!this.$v.formData.password.required && errors.push('La contraseña es querida');
			!this.$v.formData.password.maxLength && errors.push('Maximo 200 caracteres');
			!this.$v.formData.password.minLength && errors.push('Minimo 3 caracteres');
			return errors;
		},
		companyErrors() {
			const errors = [];
			!this.$v.formData.company.required && errors.push('La empresa es querida');
			!this.$v.formData.company.maxLength && errors.push('Maximo 200 caracteres');
			!this.$v.formData.company.minLength && errors.push('Minimo 3 caracteres');
			return errors;
		},
		...mapGetters({
			message: 'Auth/message',
		}),
	},
	validations: {
		formData: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(200),
			},
			email: { required, email },
			password: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			company: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
		},
	},
	methods: {
		async onSubmit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				try {
					this.loading = true;
					const data = await register(this.formData);
					this.loading = false;
					switch (data.user.role) {
						case 'admin':
							this.$router.push({ name: 'inicio' });
							break;
						case 'superUser':
							this.$router.push({ name: 'inicio' });
							break;
						case 'person':
							this.$router.push({ name: 'account-guest', path: '/guest/account' });
							break;
					}
					this.snackbar({
						content: `Bienvenido ${data.user.name}`,
						color: 'success',
					});
				} catch (error) {
					this.loading = false;
					this.snackbar(generateSnackBarError(error));
				}
			}
		},
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>

<style media="screen">
.auth-class {
	background-color: #ffffff8c !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	transition: background-color 5000s ease-in-out 0s;
}
</style>
